"use client";

import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { Search } from "lucide-react";
import { useState, FormEvent } from "react";

export default function BlogHero({
    lang = "tr",
    dict,
    initialQuery = "",
}: {
    lang?: string;
    dict?: {
        common?: { home?: string };
        blog_page?: { title?: string; intro?: string; search_placeholder?: string };
    };
    initialQuery?: string;
}) {
    const router = useRouter();
    const pathname = usePathname();
    const [query, setQuery] = useState(initialQuery);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        const trimmed = query.trim();
        const target = trimmed ? `${pathname}?q=${encodeURIComponent(trimmed)}` : pathname;
        router.push(target);
    };

    return (
        <section className="bg-[#051e3c] py-20 pb-28">
            <div className="container-custom">
                <div className="mb-8 flex items-center text-[13px] font-medium text-[#8faecb]">
                    <Link href={lang === "tr" ? "/" : `/${lang}`} className="hover:text-white transition-colors">
                        {dict?.common?.home}
                    </Link>
                    <span className="mx-3 text-[10px] opacity-60">•</span>
                    <span className="text-gray-400">{dict?.blog_page?.title}</span>
                </div>

                <h1 className="mb-6 text-4xl font-bold tracking-tight text-white md:text-[42px]">
                    {dict?.blog_page?.title}
                </h1>
                <p className="mb-12 max-w-[600px] text-[16px] font-normal leading-[1.6] text-gray-300/80">
                    {dict?.blog_page?.intro}
                </p>

                <form onSubmit={handleSubmit} className="relative mx-auto max-w-[600px] lg:mx-0">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder={dict?.blog_page?.search_placeholder}
                        className="w-full rounded-[4px] bg-[#f8f9fa] py-4 pl-6 pr-14 text-[14px] text-[#333] placeholder:text-gray-500 transition-all focus:outline-none focus:ring-2 focus:ring-[#00AEEF]"
                    />
                    <button
                        type="submit"
                        className="absolute bottom-1 right-1 top-1 flex w-12 items-center justify-center rounded-[4px] bg-[#102a43] text-white transition-colors hover:bg-[#00AEEF]"
                    >
                        <Search className="h-5 w-5" />
                    </button>
                </form>
            </div>
        </section>
    );
}
